import { Component, HostBinding } from '@angular/core';
import { SideNavigationService } from '@sb-tools/typescript/services/side-navigation.service';

@Component({
    selector: 'sb-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
    constructor(private sideNavigationService: SideNavigationService) {}

    @HostBinding('class.is-expanded') get isExpanded(): boolean {
        return !this.sideNavigationService.isLeftMenuOpen;
    }
}
